import React, { useState, useContext, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Navbar, Container, Nav, NavDropdown } from 'react-bootstrap';
import NavbarCollapse from 'react-bootstrap/esm/NavbarCollapse';
import Logo from '../../assets/img/brand/artur.svg';
import LogoSmall from '../../assets/img/brand/artur_head.svg';
import menuIconURL from '../../assets/img/icons/menu_white.svg';
import { AuthContext } from '../auth/auth-context';
import { useGetUser, useGetUserAdmin, useGetVendorId } from '../../hooks/global/User';
import { useGetAvailableTranslationLong } from '../../hooks/global/Languages';
import { useGetVendors } from '../../hooks/auth/Users';
import { FaSearch, FaAlignJustify, FaUserAlt, FaCertificate, FaUserNinja, FaGlobeAmericas, FaSignOutAlt } from 'react-icons/fa';
import { useGetVendor } from '../../hooks/vendors/Vendors';

function AdminHeader() {
  const { t, i18n } = useTranslation();
  const lang = useGetAvailableTranslationLong();

  const [ toggleHamburger, setToggleHamburger ] = useState(false);
  const { logout, switchVendor, isAuthenticated } = useContext(AuthContext);

  const [ vendor, setVendor ] = useState({});

  const user = useGetUser();
  const admin = useGetUserAdmin();
  const vendorId = useGetVendorId();
  const { data } = useGetVendor();

  useEffect(() => {
    if (data) {
      setVendor(data);
    }
  }, [data]);

  const { data: vendors } = useGetVendors(user.vendor_ids);

  const handleChangeLng = (toggleLanguage) => {
    localStorage.setItem('i18nextLng', toggleLanguage);
    i18n.changeLanguage(toggleLanguage);
    return;
  };

  const handleSwitchVendor = (vendorId) => {
    switchVendor(vendorId);
  };

  return (
    <div>
      <div className="adminHeader">
        <Navbar className="navbar navbar-profile navbar-default" style={{ padding: '0px' }}>
          <Container fluid>
            <Navbar.Brand className="navbar-brand">
              <Link to={`/admin/vendors/${vendorId}/dashboard`}>
                <img src={Logo} alt="Artur.com" title="Artur.com" />
              </Link>
            </Navbar.Brand>
            <NavbarCollapse className="justify-content-end">
              <ul className="nav navbar-nav navbar-right">
                <li className="navbar-homeSub navbar-homeSubRight">
                  <span className="" style={{cursor:"pointer"}}>
                    {i18n.language}{' '}
                    <i className="">
                      <FaGlobeAmericas style={{ fontSize: '16px', verticalAlign: 'baseline' }} />
                    </i>
                  </span>

                  <ul style={{ textAlign: 'center',  cursor:"pointer" }}>
                    <li>
                      <a className="invisible"></a>
                    </li>
                    {lang &&
                      lang.length > 0 &&
                      lang.map((lng) => {
                        return (
                          <li key={lng.code} style={{ boxShadow: '2px 6px 10px 0px rgba(0, 0, 0, 0.25)' }}>
                            <a
                              className="first"
                              onClick={() => {
                                handleChangeLng(lng.code);
                              }}
                            >
                              {lng.name}
                            </a>
                          </li>
                        );
                      })}
                  </ul>
                </li>

                {isAuthenticated && (
                  <li className="navbar-homeSub navbar-homeSubRight">
                    <span className="yellowLink" style={{cursor:"pointer"}}>
                      <i className="">
                        <FaUserAlt style={{ fontSize: '18px', verticalAlign: 'baseline' }} />
                      </i>{' '}
                      {user.name} {user.surname}
                    </span>
                    {admin && (
                      <span className="yellowLink" style={{cursor:"pointer"}}>
                        <i className="">
                          <FaUserNinja style={{ fontSize: '18px', verticalAlign: 'baseline' }} />
                        </i>
                        {admin.email}
                      </span>
                    )}
                    <ul>
                      <li>
                        <a className="invisible"></a>
                      </li>
                      {vendors &&
                        vendors.length > 0 &&
                        vendors.map((vendor) => {
                          return (
                            <li key={vendor.id} className="no-break" style={{ boxShadow: '2px 6px 10px 0px rgba(0, 0, 0, 0.25)' }}>
                              <a
                                className="first"
                                onClick={() => {
                                  handleSwitchVendor(vendor.id);
                                }}
                              >
                                {vendor.name}
                              </a>
                            </li>
                          );
                        })}
                      <li>
                        <div>
                          <a onClick={logout} className="logMeOut" href="#" style={{ boxShadow: '2px 6px 10px 0px rgba(0, 0, 0, 0.25)' }}>
                            {t('login.logout').toUpperCase()}{' '}
                            <FaSignOutAlt style={{ fontSize: '16px', verticalAlign: 'baseline', paddingTop: '4px' }} />
                          </a>
                        </div>
                      </li>
                    </ul>
                  </li>
                )}
              </ul>
            </NavbarCollapse>
          </Container>
        </Navbar>

        {isAuthenticated && (
          <Navbar className="navbar navbar-admin navbar-default" expand="lg">
            <Container fluid>
              <Navbar.Toggle aria-controls="navbar-collapse" className="ms-auto">
                <img className="hamburger-menuIcon" src={menuIconURL} alt="Menu" />
              </Navbar.Toggle>
              <Navbar.Collapse id="navbar-collapse" style={{ justifyContent: 'space-between' }}>
                <Nav className="mr-auto">
                  <NavDropdown title={`${t('adminHeader.mng')} - ${vendor?.name ?? ''}`}>
                    <NavDropdown.Item onClick={() => setToggleHamburger(!toggleHamburger)} href={`/admin/vendors/${vendorId}/prize-games`}>
                      {t('adminHeader.m1')}
                    </NavDropdown.Item>
                    <NavDropdown.Item onClick={() => setToggleHamburger(!toggleHamburger)} href={`/admin/vendors/${vendorId}/invitations`}>
                      {t('adminHeader.m2')}
                    </NavDropdown.Item>
                    <NavDropdown.Item onClick={() => setToggleHamburger(!toggleHamburger)} href={`/admin/vendors/${vendorId}/widget-overview`}>
                      {t('adminHeader.m3')}
                    </NavDropdown.Item>
                    <NavDropdown.Item onClick={() => setToggleHamburger(!toggleHamburger)} href={`/admin/vendors/${vendorId}/groups`}>
                      {t('adminHeader.m4')}
                    </NavDropdown.Item>
                    <NavDropdown.Item onClick={() => setToggleHamburger(!toggleHamburger)} href={`/admin/vendors/${vendorId}/settings`}>
                      {t('adminHeader.m5')}
                    </NavDropdown.Item>
                  </NavDropdown>
                </Nav>
                <Nav className="ml-auto">
                  <Nav.Link className="no-break" onClick={() => setToggleHamburger(!toggleHamburger)} href={`/admin/vendors/${vendorId}/report`}>
                    <i className="">
                      <FaSearch style={{ fontSize: '18px', verticalAlign: 'baseline' }} />
                    </i>
                    <span className="d-inline d-lg-inline d-sm-inline">{t('adminHeader.rep')}</span>
                  </Nav.Link>
                  <Nav.Link className="no-break" onClick={() => setToggleHamburger(!toggleHamburger)} href={`/admin/vendors/${vendorId}/reviews`}>
                    <i className="">
                      <FaAlignJustify style={{ fontSize: '18px', verticalAlign: 'baseline' }} />
                    </i>
                    <span className="d-inline d-lg-inline d-sm-inline no-break">{t('adminHeader.rev')}</span>
                  </Nav.Link>
                  <Nav.Link className="no-break" onClick={() => setToggleHamburger(!toggleHamburger)} href={`/admin/vendors/${vendorId}/certificate`}>
                    <i className="">
                      <FaCertificate style={{ fontSize: '18px', verticalAlign: 'baseline' }} />
                    </i>
                    <span className="d-inline d-lg-inline d-sm-inline no-break">{t('adminHeader.cer')}</span>
                  </Nav.Link>
                </Nav>

                <Nav className="ml-auto hide-menu">
                  <NavDropdown title={`${i18n.language}`}>
                    {lang &&
                      lang.length > 0 &&
                      lang.map((lng) => {
                        return (<div key={lng.code}>
                          <NavDropdown.Item
                            className="no-break"
                            onClick={() => {
                              handleChangeLng(lng.code);
                              setToggleHamburger(!toggleHamburger);
                            }}
                          >
                            {lng.name}
                          </NavDropdown.Item>
                          </div>
                        );
                      })}
                  </NavDropdown>

                  <NavDropdown title={`${user.name} ${user.surname}`}>
                    {vendors &&
                      vendors.length > 0 &&
                      vendors.map((vendor) => {
                        return (
                          <Nav.Link key={vendor.id}
                            className="no-break"
                            onClick={() => {
                              handleSwitchVendor(vendor?.id);
                              setToggleHamburger(!toggleHamburger);
                            }}
                          >
                            {vendor.name}
                          </Nav.Link>
                        );
                      })}
                  </NavDropdown>
                </Nav>
              </Navbar.Collapse>
            </Container>
          </Navbar>
        )}
        <Link className="hamburger-brand" to={`/admin/vendors/${vendorId}/dashboard`}>
          <img src={LogoSmall} alt="Artur.com" title="Artur.com" />
        </Link>
      </div>
    </div>
  );
}

export default AdminHeader;
